.bookingPill {
  height: 20px;
  border-radius: var(--radiusSm);
  padding: 0 var(--spacingSm);
  width: fit-content;
  max-width: 300px;
}
